module.exports = "<md-toast>\n  <span class=\"md-toast-text\" flex>New ticket: {{ $ctrl.title }}</span>\n  <md-button class=\"md-icon-button\">\n    <a target=\"_blank\" ui-sref=\"ticket({ id: $ctrl.ticket._id })\">\n      <md-icon>send</md-icon>\n    </a>\n  </md-button>\n  <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n    <md-icon>close</md-icon>\n  </md-button>\n</md-toast>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/ticketNotification/toast/toast.html
// module id = 1000
// module chunks = 0